import { Box, Card, CardContent, Container, Grid, Typography, useTheme, alpha } from '@mui/material';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import GroupsIcon from '@mui/icons-material/Groups';
import PaymentsIcon from '@mui/icons-material/Payments';
import TuneIcon from '@mui/icons-material/Tune';
import DescriptionIcon from '@mui/icons-material/Description';
import InsightsIcon from '@mui/icons-material/Insights';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';

const features = [
  {
    icon: <SpaceDashboardIcon sx={{ fontSize: 32 }} />,
    title: 'Real-time dashboard',
    description: 'Revenue, active services, expiries and online payments at a glance, per operator and region.',
  },
  {
    icon: <GroupsIcon sx={{ fontSize: 32 }} />,
    title: 'Customers & operators',
    description: 'Manage clients, packets, offers and operator access across every region you serve.',
  },
  {
    icon: <PaymentsIcon sx={{ fontSize: 32 }} />,
    title: 'Payments & withdrawals',
    description: 'Collect, reconcile and track payments — in person or online — with full audit history.',
  },
  {
    icon: <TuneIcon sx={{ fontSize: 32 }} />,
    title: 'Service management',
    description: 'Create packages, set regional availability and automate activation and expiry control.',
  },
  {
    icon: <DescriptionIcon sx={{ fontSize: 32 }} />,
    title: 'Invoicing & warehouse',
    description: 'Sale and purchase invoices, items and customers — built-in, with Albanian tax in mind.',
  },
  {
    icon: <InsightsIcon sx={{ fontSize: 32 }} />,
    title: 'Advanced reporting',
    description: 'Financial performance, customer analytics and regional comparisons you can export.',
  },
];

const KeyFeaturesSection = () => {
  const theme = useTheme();

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: 'background.default' }}>
      <Container>
        <SectionHeading
          overline="One platform"
          title="Everything you need to operate"
          subtitle="The Core toolkit every Solvenda ISP gets, refined from real ISP requirements."
        />
        <Grid container spacing={3.5}>
          {features.map((f, i) => (
            <Grid item xs={12} sm={6} md={4} key={f.title}>
              <Reveal delay={i * 50} sx={{ height: '100%' }}>
                <Card
                  sx={{
                    height: '100%',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: `0 18px 40px ${alpha(theme.palette.primary.main, 0.18)}`,
                    },
                  }}
                >
                  <CardContent sx={{ p: 3.5 }}>
                    <Box
                      sx={{
                        width: 60,
                        height: 60,
                        borderRadius: 2.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 2.5,
                        color: 'primary.main',
                        bgcolor: alpha(theme.palette.primary.main, 0.12),
                      }}
                    >
                      {f.icon}
                    </Box>
                    <Typography variant="h5" component="h3" gutterBottom>
                      {f.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {f.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default KeyFeaturesSection;
